import {
  CustomerHubHomeLong,
  CustomerHubHomeShort,
  CustomerHubSingleContent,
  CustomerHubMultipleContent,
} from './content'

export const CUSTOMER_HUB = {
  label: 'Microsites',
  value: 'customer-hub',
  channel: 'web',
  disabled: false,
  navigationLimit: 8,
  tabs: ['screens', 'navigation', 'branding', 'insights', 'share'],
  freeformTemplates: [
    {
      label: 'Empty',
      description: 'Page with no initial content',
      template: 'FreeformPage',
      thumbnail: 'customer-hub-empty-page.png',
      preset: 'customer-hub-empty',
      content: [],
    },
    {
      label: 'Home Page (Long)',
      description: 'Main landing page with all content divided into sections',
      template: 'FreeformPage',
      thumbnail: 'customer-hub-home-long.png',
      preset: 'customer-hub-home-long',
      content: CustomerHubHomeLong.content,
    },
    {
      label: 'Home Page (Short)',
      description: 'Main landing page with links to other pages',
      template: 'FreeformPage',
      thumbnail: 'customer-hub-home-short.png',
      preset: 'customer-hub-home-short',
      content: CustomerHubHomeShort.content,
    },
    {
      label: 'Single Content',
      description: 'Page with placeholder for single piece of content like video or presentation',
      template: 'FreeformPage',
      thumbnail: 'customer-hub-single-content.png',
      preset: 'customer-hub-single-content',
      content: CustomerHubSingleContent.content,
    },
    {
      label: 'Multiple Content',
      description: 'Page with placeholder for multiple pieces of content like video or presentation',
      template: 'FreeformPage',
      thumbnail: 'customer-hub-multiple-content.png',
      preset: 'customer-hub-multiple-content',
      content: CustomerHubMultipleContent.content,
    },
  ],
  defaultTemplate: {
    name: 'new-screen',
    title: `New Screen`,
    template: 'FreeformPage',
    preset: 'empty',
    content: [],
  },
  unknownTemplate: 'web-hero-page.png',
  navigationAlignmentOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Center', value: 'center' },
    { label: 'Right', value: 'right' },
  ],
  navigationVisibilityOptions: [
    { label: 'Always visible', value: 'alwaysVisible', default: true },
    { label: 'Always hidden', value: 'hidden' },
    { label: 'Visible after scrolling', value: 'visibleOnScroll' },
  ],
  logoPositionOptions: [
    { label: 'Left', value: 'left', default: true },
    { label: 'Top', value: 'top' },
  ],
  authOptions: [
    { label: 'Always', value: 'always' },
    { label: 'Optional', value: 'optional' },
    { label: 'None', value: 'none' },
  ],
}
